// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_ALERTS_DATA = 'UPDATE_ALERTS_DATA'

// ------------------------------------
// Actions
// ------------------------------------
export function updateAlertData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_ALERTS_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_ALERTS_DATA] : (state, action) => {
    if (action.location.page !== 'D') {
      return state
    }
    switch (action.valueType) {
      case 'ch': {
        // mark single checkbox as checked
        const { field } = action.location
        const { value } = action.payload
        const resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[field].selected, ...value]
          : [...state.formDataValue[field].selected, value]
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              selected: resultedSelectedArray,
            }
          }
        }
      }
      case 'ch_uncheck': {
        // uncheck single checkbox
        const { field } = action.location
        const { value } = action.payload
        let resultedSelectedArray = state.formDataValue[field].selected
        if (Array.isArray(value)) {
          value.forEach(item => {
            resultedSelectedArray = resultedSelectedArray.filter(function (element) {
              return element !== item
            })
          })
        } else {
          const idIndex = state.formDataValue[field].selected.indexOf(value)
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1)
          ]
        }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              selected: resultedSelectedArray,
            }
          }
        }
      }
      case 'radio':
      case 'switch':
      case 'select': {
        // radio button template
        const { field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              radio: {
                ...state.formDataValue[field].radio,
                [value]: fieldValue,
              }
            }
          }
        }
      }
      case 'textinput' : {
        // set text value
        const { field, page } = action.location
        const { value, fieldValue } = action.payload
        if (page !== 'D') return { ...state }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              textValues: {
                ...state.formDataValue[field].textValues,
                [value]: fieldValue,
              }
            }
          }
        }
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  formDataValue: {
    emailCategory: {
      radio: {
        category: ''
      },
      textValues: {
        emailAddress: '',
      },
    },
    alertsOptions: {
      selected: []
    },
    alertSwitchers: {
      selected: []
    },
    legisCategoryAlerts: {
      radio: {
        alertType: 'newUpd'
      },
      states: {
        selected: []
      }
    },
    legisRecordAlerts: {
      radio: {
        alertType: false
      },
    },
    legisComplianceAlerts: {
      radio: {
        alertType: 'weeklyQuarterly'
      },
      states: {
        selected: []
      }
    },
    regsCategoryAlerts: {
      radio: {
        alertType: 'newUpd'
      },
      states: {
        selected: []
      }
    },
    regsRecordAlerts: {
      radio: {}
    },
    regsComplianceAlerts: {
      radio: {
        alertType: 'weeklyQuarterly'
      },
      states: {
        selected: []
      }
    },
    localCategoryAlerts: {
      radio: {
        alertType: 'newUpd'
      },
      locality: {
        selected: []
      }
    },
    localRecordAlerts: {
      radio: {}
    },
    customAlerts: {
      radio: {}
    }
  },
}

export default function emailAlertsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/emailAlerts.js